import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApi } from "services/CommonService";
import { APIS } from "constants/api.constant";

export const fetchMenuCounts = createAsyncThunk(
  "menuCount/fetchMenuCounts",
  async () => {
    const res = await getApi(APIS.GET_COUNT);
    return res?.data ?? res;
  },
);

const menuCountSlice = createSlice({
  name: "menuCount",
  initialState: {
    counts: null,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMenuCounts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMenuCounts.fulfilled, (state, action) => {
        state.counts = action.payload;
        state.loading = false;
      })
      .addCase(fetchMenuCounts.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default menuCountSlice.reducer;
